import React, { useState } from 'react';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';
import Input from '../../../../Core/Fields/Floating/Input';
import Date from '../../../../Core/Fields/Floating/Date';
import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';

function Tab1({ deliveryNoteData, activityboll }) {
  const [showActivity, setShowActivity] = useState(true);

  console.log(deliveryNoteData,"deliveryNoteData_check");
  

  return (
             <div
      className="row sidebarbox m-0"
      style={{
        padding: "8px",
        borderRadius: "5px",
        maxHeight: "74vh",
           minHeight: "74vh",
        overflowY: "scroll",
   
      }}
    >
        <div style={{     maxHeight: "74vh",}}>
      <div className="d-flex gap-3 " style={{marginBottom : '5px'}}>
        <div className="col">
          <Input
            id="numberInput"
            label="No"
            value={deliveryNoteData?.name || ''}
            readOnly
            style={{ height: '30px' }}
          />
        </div>
        <div className="col">
          <Input
            id="requireddata"
            label="Date"
            value={deliveryNoteData?.creation || ''}
            readOnly
            style={{ height: '30px' }}
          />
        </div>
      </div>

      <div className="col-12 mb-3">
        <Input
          id="customer"
          label="Customer"
          value={deliveryNoteData?.customer || 'No customer selected'}
          readOnly
          style={{ height: '30px' }}
        />
      </div>

      <div className="col-12 mb-3">
        <Input
          id="billingType"
          label="Billing Type"
          value={deliveryNoteData?.custom_billing_type || 'No Billing Type selected'}
          readOnly
          style={{ height: '30px' }}
        />
      </div>

      <div className="col-12 mb-3">
        <Input
          id="against_order"
          label={deliveryNoteData?.hasOwnProperty('against_sales_order') ? 'Against Sales Order' : 'Against Purchase Receipt'}
          value={deliveryNoteData?.against_sales_order || ''}
          readOnly
          style={{ height: '30px' }}
        />
      </div>

      <div className="col-12 mb-3">
        <Input
          id="deliveryDate"
          label="Delivery Date"
          value={deliveryNoteData?.posting_date || ''}
          readOnly
          style={{ height: '38px' }}
        />
      </div>

      <div className="col-12 mb-3 position-relative">
        <Input
          id="postingTime"
          label="Post Time Two"
          value={deliveryNoteData?.posting_time?.slice(0, 5) || ''}
          readOnly
          style={{ height: '30px', paddingRight: '35px' }}
        />
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none'
          }}
        >
          <GetIcon iconName="GoClock" size={18} />
        </span>
      </div>

      <div className="col-12 mb-3">
        <Input
          id="remarks"
          label="Remarks"
          placeholder="Remarks"
            style={{ height: '30px' }}
            readOnly
        />
      </div>

      <div className="d-flex align-items-center pb-2" style={{ marginTop: '12px' }}>
        <input
          type="checkbox"
            style={{ width: '15px', height: '15px', borderRadius: '4px', marginRight: '8px' }}
            disabled
            // value={deliveryNoteData.e}
        />
        <label style={{ color: '#00000099', fontSize: '13px' }}>
          Edit Posting Date and Time
        </label>
      </div>

      {/** Collapsible sections UI, static */}
  <div>
          <CollapsibleSection title="Accounting Dimensions">
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Cost Center"
                readOnly
                value={deliveryNoteData?.cost_center || ''}
                style={{ height: '30px' }}
              />
            </div>
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Project"
                readOnly
                value={deliveryNoteData?.project || ''}
                style={{ height: '30px' }}
              />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Payment Terms">
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Payment Terms"
                readOnly
                value={deliveryNoteData?.payment_terms || ''}
                style={{ height: '30px' }}
              />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Currency and Price List">
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Currency"
                readOnly
                value={deliveryNoteData?.currency || ''}
                style={{ height: '30px' }}
              />
            </div>
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Price List"
                readOnly
                value={deliveryNoteData?.selling_price_list || ''}
                style={{ height: '30px' }}
              />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Taxes and Charges">
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Taxes and Charges"
                readOnly
                value={deliveryNoteData?.taxes_and_charges || ''}
                style={{ height: '30px' }}
              />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Terms & Conditions">
            <div className="col-lg-12 mt-1 mb-3">
              <Input
                label="Terms and Conditions"
                readOnly
                value={deliveryNoteData?.tc_name || ''}
                style={{ height: '30px' }}
              />
            </div>
          </CollapsibleSection>

          <CollapsibleSection title="Additional Discount">
            <div className="col-lg-12 mt-3 mb-3">
              <Input
                label="Additional Discount Percentage"
                readOnly
                value={`${deliveryNoteData?.additional_discount_percentage || ""}%`}
                style={{ height: '30px' }}
              />
            </div>
          </CollapsibleSection>
        </div>


      <div style={{ height: '14vh', fontSize: '14px' }}>
        <div className="col-12">
          <div
            className="py-2 d-flex justify-content-between align-items-center"
            onClick={() => setShowActivity(!showActivity)}
          >
            <p className="firstcolor m-0" style={{ fontWeight: 450, fontSize: '18px' }}>
              Activity
            </p>
            <GetIcon
              iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
              size={22}
            />
          </div>

          {showActivity && (
            <VersionHistory
              doctype="Delivery note"
              docname={deliveryNoteData?.name}
              activityboll={activityboll}
            />
          )}
        </div>
      </div>
    </div>
        </div>

  );
}

export default Tab1;
